import * as React from "react";
import { useState, useEffect } from "react";
import { FxmsData } from "../../fxms/datas/FxData";
import { FxRenderer } from "../datas/FxRenderer";

/**
 * 알람, 공지사항을 알린다.
 * 개발자 : T/F팀
 * 개발년월 : 2022.11
 * @returns 
 */
export const FxAlarmNotify = (props) => {

  const { inloNo, index } = props;
  const [children, setChildren] = useState([]);

  useEffect(() => {
    console.log('*** FxAlarmNotify ***  index = ' + index);
    console.log('*** FxAlarmNotify ***  inloNo = ' + inloNo);
  }, []);

  useEffect(() => {
    if (inloNo > 0 ) {
      console.log('*** FxAlarmNotify ***', inloNo);
      showAlarms(inloNo);
    }
  }, [inloNo, index]);

  async function showAlarms(inloNo) {

    // 현재 경보 알람 테이블 조회
    const uri = "fxAlAlarm/cur/list";
    const para = {};
    if (inloNo > 0 ) {
      para.inloNo = inloNo;
    }

    const ret = [];
    const alarmList = await FxmsData.GET(uri, para);
    console.log('*** FxAlarmNotify *** ' + uri, para, alarmList);

    if (alarmList) {
      for (let alarm of alarmList.data) {
        ret.push(alarm);
      }
    }

    function make(index, type, message) {

      return (
        <li className={"anim" + (index + 1)} key={index}>
          <a href={"#"}>
            <p className={"alertMent"}>
              <span>{type} </span>{message}
            </p>
          </a>
        </li>
      );

    }

    const tmp = [];
    let index = 0;

    if (ret.length === 0) {
      tmp.push(make(index++, '알림', '공지사항 및 발생된 알람이 없습니다.'));
    } else {
      for (let alarm of ret) {
        tmp.push(make(index++, '알람', "(" + FxRenderer.renderDate(alarm.occurDtm) + ") '" + alarm.moName + "' 에서 '" + alarm.alarmMsg + "' 알람 발생"));
      }
    }
    setChildren(tmp);
  }

  return (
    <ul>
      {children}
    </ul>
  );
};
